import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

export const InstallPrompt: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setIsVisible(false);
    }
    setDeferredPrompt(null);
  };

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        left: '24px',
        zIndex: 90,
        background: 'var(--bg-secondary)',
        border: '1px solid var(--accent-primary)',
        borderRadius: '16px',
        padding: '14px 20px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
      }}
    >
      <div>
        <div style={{ fontWeight: '700', fontSize: '0.95rem' }}>Install Cordle PWA</div>
        <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Fast offline access on Desktop & Mobile</div>
      </div>
      <button
        onClick={handleInstall}
        style={{
          padding: '8px 16px',
          borderRadius: '20px',
          background: 'var(--accent-gradient)',
          color: '#ffffff',
          fontWeight: '700',
          fontSize: '0.85rem',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        }}
      >
        <Download size={14} /> Install
      </button>
      <button onClick={() => setIsVisible(false)} style={{ color: 'var(--text-muted)' }}>
        <X size={16} />
      </button>
    </div>
  );
};
